























import { Component, Vue, Prop } from 'vue-property-decorator';
import CarShow from '@/components/Car/CarShow.vue';
import { GQL_currentUnitCars_currentUnit_cars } from '@/queries/__generated__/currentUnitCars';

@Component({
  components: {
    CarShow,
  },
})
export default class CarShowButton extends Vue {
  @Prop() public car!: GQL_currentUnitCars_currentUnit_cars;
  public showDialog = false;
}
